<template>
  <div>
    <v-progress-circular v-if="loading" size="20" indeterminate color="rgba(0, 0, 0, 0.87)" />
    <div v-else>
      <v-simple-table dense class="table-samp-result">
        <template v-slot:default>
          <thead>
            <tr>
              <th>BASE SIG-R</th>
              <th>MÊS</th>
              <th class="text-right">COM ENERGIA</th>
              <th class="text-right">SEM ENERGIA</th>
              <th class="text-right">IMPORTADAS EM</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, j) in resultado" :key="j" :class="j % 2 === 1 ? 'zebra1' : ''">
              <td>{{ item.base }}</td>
              <td>{{ item.mes | addLeadingZero }}</td>
              <td
                class="text-right"
                style="font-size: 12px !important"
                :class="{
                  'status-samp-ok': item.total_linhas_energias_nao_zeradas > 0,
                  'status-samp-erro': item.total_linhas_energias_nao_zeradas <= 0
                }"
              >
                {{ item.total_linhas_energias_nao_zeradas | parseNumberToIntegerBR }}
              </td>
              <td
                class="text-right"
                style="font-size: 12px !important"
                :class="{
                  'status-samp-alerta': item.total_linhas_energias_zeradas > 0,
                  'status-samp-ok': item.total_linhas_energias_zeradas <= 0
                }"
              >
                {{ item.total_linhas_energias_zeradas | parseNumberToIntegerBR }}
              </td>
              <td class="text-right">
                {{ item.importado_em | parseToDateTimeBR }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
  import ValidacoesSampService from '@/services/ValidacoesSampService';

  export default {
    name: 'TabelaResumoImportacoesBasesSigr',
    props: {
      bdgdVersao: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      loading: false,
      resultado: []
    }),
    mounted() {
      this.getResumoImportacoesBasesSigr();
    },
    methods: {
      getResumoImportacoesBasesSigr() {
        this.loading = true;
        ValidacoesSampService.getResumoImportacoesBasesSigr(this.bdgdVersao.id)
          .then((response) => {
            this.resultado = response.data;
          })
          .catch((err) => {
            console.log('Erro: ', err);
            this.$toast.error('Erro ao buscar o resumo de importações das bases SIG-R.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      }
    },
    watch: {
      bdgdVersao() {
        this.getResumoImportacoesBasesSigr();
      }
    }
  };
</script>
